import { PieChart, Pie, Cell } from "recharts";
import { colors } from "../../../styles/figmaColors";

export type DonutChartDSSize = "S" | "M" | "L";

export interface DonutChartDSProps {
  // Percentage of the donut filled with the accent color (0 to 100).
  value: number;
  size: DonutChartDSSize;
}

const THICKNESS = 10;

const SIZES: Record<DonutChartDSSize, number> = {
  S: 64,
  M: 96,
  L: 120,
};

export const DonutChartDS = (props: DonutChartDSProps) => {
  const size = SIZES[props.size];
  const data = [{ value: props.value }, { value: 100 - props.value }];

  return (
    <PieChart
      width={size}
      height={size}
      margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
    >
      <Pie
        data={data}
        dataKey="value"
        cx="50%"
        cy="50%"
        innerRadius={size / 2 - THICKNESS}
        outerRadius={size / 2}
        startAngle={90}
        endAngle={-270}
        stroke="none"
        isAnimationActive={false}
      >
        <Cell fill={colors["colors/accent/500"]} />
        <Cell fill={colors["colors/text/black"]} />
      </Pie>
    </PieChart>
  );
};
